import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=5f7c3ad4&scoped=true&"
import script from "./claims.vue?vue&type=script&lang=js&"
export * from "./claims.vue?vue&type=script&lang=js&"
import style0 from "./claims.vue?vue&type=style&index=0&id=5f7c3ad4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c3ad4",
  null
  
)

export default component.exports